import { HarborRoleDashboard } from './HarborRoleDashboard';

const MarinaManagerDashboard = () => {
  return <HarborRoleDashboard variant="marina" />;
};

export { MarinaManagerDashboard };
